import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { ChevronRight } from 'lucide-react';
interface Slide8Props {
  onNavigate: (slide: number) => void;
}
export function Slide8({
  onNavigate
}: Slide8Props) {
  const menuItems = [{
    title: 'MEDICAL INFORMATION & CONTACT',
    slide: 9
  }, {
    title: 'PREGNANCY CONSIDERATIONS',
    slide: 10
  }, {
    title: 'FULL PRESCRIBING INFORMATION',
    slide: 11
  }];
  return <SlideLayout data-id="element-234">
      <div className="w-full max-w-4xl mx-auto space-y-12" data-id="element-235">
        <h1 className="text-4xl font-bold text-white text-center mb-8 uppercase" data-id="element-236">
          ADDITIONAL INFORMATION
        </h1>
        <div className="grid grid-cols-1 gap-6" data-id="element-237">
          {menuItems.map((item, index) => <button key={index} onClick={() => onNavigate(item.slide)} className="frosted-card rounded-xl p-8 hover:bg-white/25 transition-all duration-300 hover:shadow-xl group flex items-center justify-between" data-id="element-238">
              <span className="text-2xl font-bold text-[#1B3A5C] text-left" data-id="element-239">
                {item.title}
              </span>
              <div className="w-12 h-12 flex items-center justify-center" data-id="element-240">
                <ChevronRight className="w-10 h-10 text-[#6B46C1] stroke-[3]" data-id="element-241" />
              </div>
            </button>)}
        </div>
      </div>
    </SlideLayout>;
}